import type { ReactNode } from 'react'
import React from 'react'
import { HorizontalStack } from '../HorizontalStack'
import { Icon } from '../Icon'

export type IconValueBlockProps = { children?: ReactNode; icon: string; value?: ReactNode; help?: string; className?: string }
export const IconValueBlock = ({ children, icon, value, help, className }: IconValueBlockProps) => {
  return (
    <HorizontalStack gap={1} className="align-items-start">
      <div>
        <Icon name={icon} className={className} />
      </div>
      <div>
        <div title={help}>{value || children}</div>
      </div>
    </HorizontalStack>
  )
}
